// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";
import { BarChart } from "./BarChart";

export const RevenueTab = ({ d }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Monthly Revenue</CardTitle>
      </CardHeader>
      <CardContent>
        <BarChart data={d.revenueMonthly} valueKey="revenue" labelKey="month" />
      </CardContent>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          Marketplace Revenue Breakdown
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {d.marketplaceRevenue.map((m) => (
            <div
              key={m.marketplace}
              className="flex items-center justify-between p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50"
            >
              <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                {m.marketplace}
              </span>
              <span className="text-lg font-bold text-slate-900 dark:text-slate-100">
                ${(m.revenue / 1000).toFixed(1)}K
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          Net vs Gross & Refund Deductions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {d.revenueMonthly.map((m) => (
            <div key={m.month} className="flex items-center gap-3">
              <span className="text-xs text-slate-500 dark:text-slate-400 w-10 text-right">
                {m.month}
              </span>
              <div className="flex-1 flex gap-1">
                <div
                  className="h-4 bg-indigo-500 rounded-l"
                  style={{
                    width: `${((m.revenue - m.refunds) / m.revenue) * 100}%`,
                  }}
                />
                <div
                  className="h-4 bg-rose-400 rounded-r"
                  style={{ width: `${(m.refunds / m.revenue) * 100}%` }}
                />
              </div>
              <span className="text-xs text-slate-700 dark:text-slate-300 w-16 text-right">
                ${(m.revenue / 1000).toFixed(1)}K
              </span>
              <span className="text-[10px] text-rose-500 w-12 text-right">
                -${m.refunds}
              </span>
            </div>
          ))}
          <div className="flex items-center gap-4 mt-2 pt-2 border-t border-slate-100 dark:border-slate-800">
            <span className="flex items-center gap-1.5 text-xs text-slate-500">
              <span className="w-3 h-3 rounded bg-indigo-500" />
              Net Revenue
            </span>
            <span className="flex items-center gap-1.5 text-xs text-slate-500">
              <span className="w-3 h-3 rounded bg-rose-400" />
              Refunds
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);
